/**
 * License Intelligence Vendor Endpoints Mock Data
 *
 * Mock data for the getEndpoints API.
 * In production, this data will come from:
 * POST /ECM/api/v5/getEndpoints?max=500&offset=0&connectionType=SAP
 */

import type { VendorEndpoint } from '../data-layer/licenseManagementApi';

export const LICENSE_INTELLIGENCE_VENDOR_ENDPOINTS_DATA: VendorEndpoint[] = [
  { id: '2', endpointname: 'S4HANA', displayName: 'SAP System S42021' },
  { id: '13', endpointname: 'S5HANA', displayName: 'S5HANA' },
  { id: '17', endpointname: 'S4HANA_2', displayName: 'S4HANA_2' },
  {
    id: '19',
    endpointname: 'S4HANA_MasterData',
    displayName: 'S4HANA_MasterData',
  },
  { id: '27', endpointname: 'S4HANAnew', displayName: 'S4HANAnew' },
  { id: '32', endpointname: 'S4HANA_AA', displayName: 'S4HANA_AA' },
  { id: '33', endpointname: 'S4HANA_AB', displayName: 'S4HANA_AB' },
  { id: '46', endpointname: 'SAP_ECC_IDES', displayName: 'ECCCLN800' },
  { id: '70', endpointname: 'SAP_ECC_IDES_2', displayName: 'SAP_ECC_IDES_2' },
  { id: '74', endpointname: 'S4HANA_QA', displayName: 'S4HANA_QA' },
  { id: '170', endpointname: '10_10_SAP_EP', displayName: '10_10_SAP_EP' },
  { id: '172', endpointname: '11_10_EP_SAP1', displayName: '11_10_EP_SAP1' },
  { id: '903', endpointname: 'SAP System', displayName: 'SAP System demo' },
  { id: '925', endpointname: 'SAPS4HANA', displayName: 'SAPS4HANA' },
  { id: '1122', endpointname: 'SAPS4HVista', displayName: 'SAPS4HVista' },
];

export default LICENSE_INTELLIGENCE_VENDOR_ENDPOINTS_DATA;
